import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import { addHours, format } from 'date-fns';

import { addLocale, locale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';

import { FaCalendarAlt } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';

import { Api } from '../../../../services/api';
import { CalendarPague, ConfirmDialogPague } from '../../../../styles/primeReactConfig';
import { confirmFooter } from '../../../confirmFooter';

import { associado_id, userInfo } from '../../../../services/authHandlers';

export const PersonalCobranca = ({ close, rowInfo, toast, reload }) => {
  const [descricao, setDescricao] = useState('');
  const [dataVencimento, setDataVencimento] = useState('');
  const [codigoDebito, setCodigoDebito] = useState('');


  const [loading, setLoading] = useState(false);
  const today = new Date();
  addLocale('pt-BR', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Claro'
  });
  locale('pt-BR');

  const getCobrancaInfo = async () => {
    try {
      setCodigoDebito(rowInfo.codigo_debito)
      setDescricao(rowInfo.cobranca_descricao);
      setDataVencimento(addHours(new Date(rowInfo.data_vencimento_primeiro_boleto), 3));
    } catch (error) {
      console.log(error.response)
      toast('error', 'Serviço indisponível, tente novamente mais tarde')
    }
  };
  const updateCobrancaInfo = async () => {
    const associado_operador_id = userInfo.associado_id || associado_id;
    const updateData = {
      cobranca_descricao: descricao,
      data_vencimento_primeiro_boleto: format(dataVencimento, "yyyy-MM-dd"),
      codigo_debito: codigoDebito,
      associado_id: associado_operador_id
    }
    setLoading(true)
    try {
      await Api.put(`/cobranca/updateInfoCobranca/${rowInfo.cobranca_id}`, updateData);
      toast('success', 'Informações atualizadas com sucesso!')
      reload()
      close()
    } catch (error) {
      console.log(error.response)
      toast('error', 'Erro ao atualizar as infromações do cliente')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCobrancaInfo()
  }, [])

  function handleUpdate(event) {
    event.preventDefault()
    confirmDialog({
      message: "Deseja atualizar as informações da cobrança selecionada?",
      header: "Atualizar Cobrança",
      icon: <FaCircleInfo />,
      acceptLabel: "Sim",
      accept: () => updateCobrancaInfo(),
      rejectLabel: "Não",
      pt: ConfirmDialogPague,
      footer: (e) => confirmFooter(e)
    })
  }

  return (
    <Dialog
      visible
      header="Informações da Cobrança"
      onHide={() => close()}
      style={{
        heigth: '30vw',
        width: '25em',
      }}
    >
      <ConfirmDialog />
      <div className="grid text-lg font-semibold mt-1 p-1">
        <form onSubmit={(e) => handleUpdate(e)}>
          <div className="grid w-full" >

            <div className="w-full text-left grid mt-2">
              <label htmlFor="description">Descrição da Cobrança</label>
              <InputTextarea
                rows={1}
                cols={30}
                value={descricao}
                maxLength={499}
                onChange={(e) => setDescricao(e.target.value)}
                id="description"
                type="text"
                autoResize
                required
              />
            </div>

            <div className="w-full text-left grid mt-2">
              <label htmlFor="description">Código Débito</label>
              <InputText
                maxLength={200}
                value={codigoDebito}
                onChange={(e) => setCodigoDebito(e.target.value)}
                id="code"
                type="text"
                required
              />
            </div>

            <div className="w-full text-left grid mt-2">
              <label htmlFor="vencimento">Data de vencimento</label>
              <Calendar
                value={dataVencimento}
                maxDate={today}
                pt={CalendarPague}
                locale="pt-BR"
                dateFormat="dd/mm/yy"
                onChange={(e) => setDataVencimento(e.value)}
                yearRange="1900:2030"
                showOnFocus={false}
                showIcon
                icon={<FaCalendarAlt className={
                  classNames('px-4 rounded-r-lg',
                    'w-[50px] h-full',
                    'bg-sky-400 text-white hover:bg-sky-500',
                    'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                  )}
                />}
                id="vencimento"
                required
                mask="99/99/9999"
              />
            </div>

          </div>
          <div className="w-full grid mt-5 px-3 text-center">
            <Button
              loading={loading}
              label="Atualizar"
              type="submit"
              severity='success'
            />
          </div>
        </form>
      </div>
    </Dialog>
  )
}
